import { put, takeLatest } from 'redux-saga/effects';
import { innerRangeActions } from './slice';
import { settingsActions } from 'reduxStore/settings/slice';
import { Notification } from 'zComponents/atoms';

export function* triggerSync() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		const res = yield superFetch.post(`/innerRange/sync`);
		if (res.statusCode === 200) {
			yield put(settingsActions.loadOrgSettings());
			yield put(innerRangeActions.triggerSyncSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to trigger Inner Range sync.');
		yield put(innerRangeActions.triggerSyncError(error.message));
	}
}

export default function* innerRangeSagas() {
	yield takeLatest(innerRangeActions.triggerSync, triggerSync);
}
